import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";

export default function TermsPage() {
  return (
    <>
      <Navbar />
      <div style={{ padding: "40px", maxWidth: "800px", margin: "0 auto" }}>
        <h1>Terms and Conditions</h1>
        <p><strong>Effective Date:</strong> June 15, 2025</p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Quizzards’s platform (“the Service”), you agree to be bound by these Terms and Conditions. If you do not agree with any part of the terms, you may not use the Service.
        </p>

        <h2>2. Services Provided</h2>
        <p>
          Quizzards provides software tools to assist with online learning, testing, performance tracking, and educational analytics. Services may include personalized dashboards, test generation, and content recommendations.
        </p>

        <h2>3. User Accounts</h2>
        <p>
          To access certain features, you must create an account. You agree to provide accurate information and keep it up-to-date. You are responsible for maintaining the confidentiality of your login credentials.
        </p>

        <h2>4. Use of the Platform</h2>
        <p>
          You agree to use Quizzards’s platform only for lawful purposes. You must not:
        </p>
        <ul>
          <li>Upload harmful or misleading content</li>
          <li>Attempt to gain unauthorized access to the system</li>
          <li>Violate intellectual property rights</li>
        </ul>

        <h2>5. Privacy</h2>
        <p>
          Our use of your information is governed by our <a href="/privacy">Privacy Policy</a>. By using Quizzards, you consent to our collection and use of personal data as described there.
        </p>

        <h2>6. Intellectual Property</h2>
        <p>
          All content, software, and designs on this platform are the property of Quizzards or its licensors. You may not reproduce or redistribute any materials without written permission.
        </p>

        <h2>7. Termination</h2>
        <p>
          We reserve the right to suspend or terminate your account if you violate these terms or misuse the platform.
        </p>

        <h2>8. Disclaimer of Warranties</h2>
        <p>
          Quizzards is provided “as is” without warranties of any kind. We do not guarantee uninterrupted service, accuracy of results, or suitability for specific educational purposes. By continuing, you agree that the service will begin immediately and you waive your right to cancel within 14 days under the Consumer Contracts Regulations 2013.
        </p>

        <h2>9. Limitation of Liability</h2>
        <p>
          In no event shall Quizzards be liable for indirect, incidental, or consequential damages arising from your use of the platform.
        </p>

        <h2>10. Changes to Terms</h2>
        <p>
          We may revise these terms at any time. Continued use of the Service after changes are made constitutes your acceptance of the new terms.
        </p>

        <h2>11. Contact</h2>
        <p>
          For questions about these Terms, please contact us.        </p>
      </div>
      <Footer />
    </>
  );
}
